/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';

import Link from '../../../common/components/Link';

import { Copyright, LinkWrapper, Wrapper } from './styled-components';

const Footer = () => (
  <Wrapper>
    <Copyright>Copyright &copy; {moment().format('YYYY')}</Copyright>
    {' | '}
    <LinkWrapper>
      <Link to="/privacy-policy" target="_blank">
        Privacy Policy
      </Link>
    </LinkWrapper>
    {' | '}
    <LinkWrapper>
      <Link to="/tos" target="_blank">
        Terms of Service
      </Link>
    </LinkWrapper>
    {' | '}
    <LinkWrapper>
      <Link to="https://stacksports.com/support" target="_blank">
        Help
      </Link>
    </LinkWrapper>
  </Wrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Footer/index.js